import { render, staticRenderFns } from "./OrganizationalStatistics.vue?vue&type=template&id=3d1c7cb6&scoped=true"
import script from "./OrganizationalStatistics.vue?vue&type=script&lang=js"
export * from "./OrganizationalStatistics.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalStatistics.vue?vue&type=style&index=0&id=3d1c7cb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c7cb6",
  null
  
)

export default component.exports